import React from 'react';
import './index.scss';
import {
  formatPrice,
  formatTextFloat,
  formatVolume,
} from '../../../../../helpers/Text';
import { formatDataBidAsk, ATO, ATC } from '../../../../../helpers/Common';
import { getColorPrice, getColorATOAndATC } from '../../../../../helpers/Color';
import { includes } from 'lodash';

const OPACITY = 0.75;

class Row extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getColor = value => {
    const { REFERENCE_PRICE, CEILING_PRICE, FLOOR_PRICE } = this.props;

    return getColorPrice(
      value,
      REFERENCE_PRICE,
      CEILING_PRICE,
      FLOOR_PRICE,
      'bg',
    );
  };

  getTextColor = () => {
    if (includes([ATO, ATC], this.getBidValue())) {
      return '#F5761D';
    }
    return '#FFF';
  };

  getBidAskValue = (value, isDerivatives) => {
    return isDerivatives ? value : formatPrice(value);
  };

  getBidValue = () => {
    const {
      item: { BID, BID_VOLUME, TRADING_DATE, comGroupCode },
      isDerivatives,
      marketStatus,
      isBest1,
    } = this.props;
    const bidValue = this.getBidAskValue(BID, isDerivatives);
    if (!isBest1) {
      return formatTextFloat(bidValue);
    }
    return (
      formatDataBidAsk(
        BID,
        BID_VOLUME,
        TRADING_DATE,
        isDerivatives,
        marketStatus,
        comGroupCode,
      ) || formatTextFloat(bidValue)
    );
  };

  getAskValue = () => {
    const {
      item: { ASK, ASK_VOLUME, TRADING_DATE, comGroupCode },
      marketStatus,
      isBest1,
      isDerivatives,
    } = this.props;
    const askValue = this.getBidAskValue(ASK, isDerivatives);

    if (!isBest1) {
      return formatTextFloat(askValue);
    }
    return (
      formatDataBidAsk(
        askValue,
        ASK_VOLUME,
        TRADING_DATE,
        isDerivatives,
        marketStatus,
        comGroupCode,
      ) || formatTextFloat(askValue)
    );
  };

  getBidColor = () => {
    const {
      item: { BID },
    } = this.props;

    if (includes([ATO, ATC], this.getBidValue())) {
      return getColorATOAndATC();
    }
    if (this.getBidValue() === 0) {
      return null;
    }
    return this.getColor(BID);
  };

  getAskColor = () => {
    const {
      item: { ASK },
    } = this.props;

    if (includes([ATO, ATC], this.getBidValue())) {
      return getColorATOAndATC();
    }
    if (this.getAskValue() === 0) {
      return null;
    }
    return this.getColor(ASK);
  };

  getBidVolume = () => {
    const {
      item: { BID, BID_VOLUME },
      isDerivatives,
    } = this.props;

    if (BID === 0 && !includes([ATC, ATO], this.getBidValue())) {
      return '--';
    }
    return isDerivatives
      ? BID_VOLUME
      : formatTextFloat(formatVolume(BID_VOLUME));
  };

  getAskVolume = () => {
    const {
      item: { ASK, ASK_VOLUME },
      isDerivatives,
    } = this.props;

    if (ASK === 0 && !includes([ATC, ATO], this.getAskValue())) {
      return '--';
    }
    return isDerivatives
      ? ASK_VOLUME
      : formatTextFloat(formatVolume(ASK_VOLUME));
  };

  render() {
    const {
      item: { BID, BID_VOLUME, ASK, ASK_VOLUME },
      maxBidValue,
      maxAskValue,
    } = this.props;
    const maxValueArr = [maxBidValue, maxAskValue];
    const maxValue = Math.max(...maxValueArr);

    const bidWidth = (BID_VOLUME * 100) / maxValue || 0;
    const askWidth = (ASK_VOLUME * 100) / maxValue || 0;

    return (
      <div className="row-wrapper">
        <div className="box-column">
          <div className="box-column--left">
            <div />
            <div
              className={`main-text d-flex justify-content-end ${this.getBidColor()}`}
              style={{
                width: `${bidWidth}%`,
                color: this.getTextColor(BID),
                opacity: OPACITY,
              }}
            >
              <span className="bar-text mr-3">{this.getBidValue()}</span>
            </div>
            <span className="absolute-text-left">{this.getBidVolume()}</span>
          </div>
          <div className="box-column--right">
            <div
              className={`main-text d-flex justify-content-start ${this.getAskColor()}`}
              style={{
                width: `${askWidth}%`,
                color: this.getTextColor(ASK),
                opacity: OPACITY,
              }}
            >
              <span className="bar-text ml-3">{this.getAskValue()}</span>
            </div>
            <div />
            <span className="absolute-text-right">{this.getAskVolume()}</span>
          </div>
        </div>
      </div>
    );
  }
}

export default Row;
